import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { brandName, outcomes } from '../data/copy';
export function FinalCtaSection() {
  const negatives = outcomes.filter(outcome => !outcome.positive);
  const positives = outcomes.filter(outcome => outcome.positive);
  return <section className="defer-paint w-full bg-paper-soft py-14 sm:py-20" aria-labelledby="final-cta-heading" data-id="element-71" data-mp="3vrulr0zp6agy">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-72" data-mp="2y311t5a9gybt">
        <Pill tone="rust" data-id="element-73" data-mp="334qfksovbq3l">La prossima settimana</Pill>
        <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-display text-[2.1rem] font-bold uppercase leading-[1.04] text-pine sm:text-5xl" data-id="element-74" data-mp="3831pt4j2s2mc">
          Puoi continuare a preparare ogni allenamento partendo da zero…
        </h2>

        <div className="mx-auto mt-12 grid max-w-4xl items-stretch gap-4 text-left md:grid-cols-[1fr_auto_1fr]" data-id="element-75" data-mp="2fdb5ueuri6ib">
          <div className="rounded-2xl border border-line bg-paper-deep p-6 sm:p-7" data-id="element-76" data-mp="2kbwbitss9ie5">
            <h3 className="font-display text-xl font-bold uppercase text-ink" data-id="element-77" data-mp="2daoxtywvqkvk">
              Continua a improvvisare
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-78" data-mp="28f062hr3q89t">
              {negatives.map(outcome => <li key={outcome.text} className="flex items-start gap-2.5 font-sans text-sm leading-relaxed text-ink-muted" data-id="element-79" data-mp="23kvx5sy9zq63">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-rust" strokeWidth={2.8} aria-hidden="true" data-id="element-80" data-mp="1yl171rmbr4m3" />
                  {outcome.text}
                </li>)}
            </ul>
          </div>
          <p className="self-center text-center font-display text-3xl font-bold uppercase text-ember" data-id="element-81" data-mp="1poih8o9e3wtq">
            Oppure
          </p>
          <div className="rounded-2xl bg-pine p-6 shadow-xl shadow-pine/25 sm:p-7" data-id="element-82" data-mp="1fohuescbayks">
            <h3 className="font-display text-xl font-bold uppercase text-paper-soft" data-id="element-83" data-mp="3f1djh085scf0">
              Prendi {brandName}
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-84" data-mp="3a3c2ckuamn66">
              {positives.map(outcome => <li key={outcome.text} className="flex items-start gap-2.5 font-sans text-sm font-semibold leading-relaxed text-paper-soft" data-id="element-85" data-mp="18dd9diuvy5zx">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-pine-light" strokeWidth={2.8} aria-hidden="true" data-id="element-86" data-mp="1d4lh8agkhjaz" />
                  {outcome.text}
                </li>)}
            </ul>
          </div>
        </div>

        <h3 className="mx-auto mt-14 max-w-2xl font-display text-2xl font-bold uppercase leading-tight text-ink sm:text-3xl" data-id="element-87" data-mp="13ea0fnbsbfmo">
          Non hai bisogno di ricordare centinaia di esercizi.
        </h3>
        <p className="mx-auto mt-3 max-w-prose font-sans text-base leading-relaxed text-ink-muted sm:text-lg" data-id="element-88" data-mp="1w1wejpin22ns">
          Hai bisogno di un sistema che ti aiuti a scegliere, mostrare,
          correggere e progredire.
        </p>

        <CtaButton size="large" className="mt-8 w-full sm:w-auto" data-id="element-89" data-mp="6nrempgxigwe">
          Ottieni {brandName} ora
        </CtaButton>
        <p className="mt-4 font-sans text-xs text-ink-muted" data-id="element-90" data-mp="apl9ui8cusp6">
          Pagamento sicuro · accesso immediato · garanzia di 7 giorni
        </p>
      </div>
    </section>;
}